import React from 'react';
import ReactDOM from 'react-dom/client';
import Admin from './Admin';
import ContactFormFrontend from './compositions/ContactFormFrontend';
import './fonts/NunitoSans.ttf';
import {GlobalContextProvider} from "./contexts/GlobalContext";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";


const isAdmin = window.location.href.includes('admin/plugin');

if (isAdmin) {
  const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
        <GlobalContextProvider>
          <Admin/>
        </GlobalContextProvider>
    </React.StrictMode>
  );
}

if (!isAdmin) {
  
  const frontendContainers = document.querySelectorAll('[id^="zr-contact-form-frontend-"]');
  
  frontendContainers.forEach((container) => {
    const configData = container.getAttribute('data-config') || '';
    const apiUrl = container.getAttribute('data-api-url') || '';
    const formId = container.getAttribute('data-form-id') || 'default';
    
    try {
      const frontendRoot = ReactDOM.createRoot(container as HTMLElement);
      frontendRoot.render(
        <React.StrictMode>
          <GlobalContextProvider>
            <ContactFormFrontend 
              configData={configData}
              apiUrl={apiUrl}
              className="zr-contact-form-wrapper"
            />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              containerId={`toast-container-${formId}`}
            />
          </GlobalContextProvider>
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to mount contact form:', formId, error);
    }
  });
}
